import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TravelBindMdl } from './../../../Models/TravelBindMdl';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { TravelPolicyModel } from '../../../Models/TravelPolicyModel';
import { LanguageService } from '../../../Services/languageService';
import { TravelProposalMdl } from '../../../Models/TravelProposalMdl';
import { userService } from '../../../Services/userService';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { motorProposalService } from '../../../Services/motorProposalService';
import Swal from 'sweetalert2';

@Component({
    selector: 'TravelNewProposalConfirm',
    templateUrl: './TravelNewProposalConfirm.html',
    styleUrls: ['./TravelNewProposalConfirm.css']
})
export class TravelNewProposalConfirm {
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public travelBindObj: TravelBindMdl = new TravelBindMdl();
    public travelPolicyObj: TravelPolicyModel = new TravelPolicyModel();
    public proposalobj: TravelProposalMdl = new TravelProposalMdl();
    public isShowLoading: boolean = false;
    public LngSubscription: Subscription;
    public Lng: string;
    public isMore: boolean = false;
    public BtnText: string;
    public IsPromoApplied: boolean = false;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private userinfo: userService) {


        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }
        this.BtnText = this.Lng == "en" ? "View Details" : "عرض التفاصيل";
        this.getBindInfo();


    }
    getBindInfo() {
        if (sessionStorage.getItem("TravelBindObj") != null) {

            //this.travelBindObj = JSON.parse(sessionStorage.getItem("TravelBindObj"));
            this.travelBindObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("TravelBindObj")));

            if (this.travelBindObj.propoalObj.PromoDiscount > 0) {
                this.IsPromoApplied = true;
            }

        }
        else {
            this.IsPromoApplied = false;
            sessionStorage.setItem("CurrentRoute", "TravelPolicy");
            this.router.navigate(['NewDashboard/TravelPolicy']);
        }

    }

    goNext() {
        sessionStorage.setItem("CurrentRoute", "TravelBasicInfo");
        this.router.navigate(['NewDashboard/TravelProposalForm/TravelBasicInfo']);
    }


    showmore() {
        if (this.isMore == true) {
            this.isMore = false;
            this.BtnText = this.Lng == "en" ? "View Details" : "عرض التفاصيل";
            //  this.BtnText="View Details";
        }
        else if (this.isMore == false) {
            this.isMore = true;
            this.BtnText = this.Lng == "en" ? "Hide Details" : "اخفاء التفاصيل";
            //this.BtnText="Hide Details";
        }
    }

    ApplyPromo() {

        this.isShowLoading = true;

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.travelBindObj));

        //this.http.post<TravelBindMdl>(this.url.baseURL + "travelBind/ApplyTravelPromoCode", this.travelBindObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "travelBind/ApplyTravelPromoCode", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
            //this.travelBindObj = result;
            this.isShowLoading = false;

            //New Line Start
            this.objPayloadResponse = result;
            this.travelBindObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            //NewLine End


            if (this.travelBindObj.st.StatusCode == "S") {
                //sessionStorage.setItem("TravelBindObj", JSON.stringify(this.travelBindObj));
                sessionStorage.setItem("TravelBindObj", this.EncriptService.EncriptObject(JSON.stringify(this.travelBindObj)));

                this.IsPromoApplied = true;
                this.Lng == "en" ? Swal(this.travelBindObj.st.StatusDesc) : Swal(this.travelBindObj.st.StatusDescAr);
            }
            else {
                this.travelBindObj.propoalObj.PromoCode = '';
                Swal(this.travelBindObj.st.StatusDesc);
            }
        }, (error) => {
            this.userinfo.checkTokenStatus(error);
            this.isShowLoading = false;
            this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
        });
    }
}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelNewProposalConfirm/TravelNewProposalConfirm.ts